import React,{useState,}from 'react'
import { Modal,Form,Input, Button,message, DatePicker,} from 'antd';
import { useBnsYiXiangKeHuAddMutation } from '../../store/ReactWebSiteApi';
import MediaForm from '../../promote/media/MediaForm';
import dayjs from 'dayjs';
import GetUserDept from '../../cpn/GetUserDept';
import ClientDesc from './ClientDesc';
import GetWebGoods from '../goods/GetWebGoods';
function LeadAdd() {    
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);   
    const [add]  = useBnsYiXiangKeHuAddMutation()
    const [info,setInfo] = useState({
        byxkh_content:'',
    });
    //返回详情
    const [openCheck, setopenCheck] = useState({id:'',open:false})
    return (
            <>
                <Button
                    onClick={() => {setOpen(true)}}
                    type='primary'
                >新增</Button>
                <Modal
                    width={1000}
                    open={open}
                    title='新增客户'
                    okText="提交"
                    cancelText="取消"
                    onCancel={() => {setOpen(false);}}
                    onOk={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                form.resetFields();  
                                add({
                                    "byxkh_bg_id" : info.byxkh_bg_id,
                                    "byxkh_bg_name" : info.byxkh_bg_name,
                                    "byxkh_cid" : localStorage.getItem('eu_id'),
                                    "byxkh_cname" : localStorage.getItem('eu_name'),
                                    "byxkh_content" : info.byxkh_content,
                                    "byxkh_dept_id" : info.byxkh_dept_id,
                                    "byxkh_dept_name" : info.byxkh_dept_name,
                                    "byxkh_e_id" : localStorage.getItem('e_id'),
                                    "byxkh_meijie_id" : info.byxkh_meijie_id,
                                    "byxkh_meijie_name" : info.byxkh_meijie_name,
                                    "byxkh_name" : info.byxkh_name,
                                    "byxkh_riqi" : info.byxkh_riqi,                        
                                }).then((res) => {
                                    if (res.data.Status === 'success') {
                                        message.info('新增成功！');
                                        setOpen(false);
                                    }
                                    if (res.data.Status === "fail") {
                                        message.error('新增失败！'+res.data.Message)
                                    }
                                })                        
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });                    
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_client_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3 }}
                    >
                        <GetUserDept 
                            label='部门'
                            required
                            wrapperCol={{span:10}} 
                            getUserDept={(e,f) => {
                                setInfo(prevState=>({...prevState,byxkh_dept_id:e,byxkh_dept_name:f}))
                            }}
                        />
                        <Form.Item name="name" label='客户名称' wrapperCol={{span:20}} required>
                            <Input 
                                onChange={(e) => {setInfo(prevState=>({...prevState,byxkh_name:e.target.value}))}}
                            />
                        </Form.Item>                       
                        <MediaForm
                            required
                            wrapperCol={{span:10}}
                            onChange={(e,f) => {
                                setInfo(prevState=>({...prevState,byxkh_meijie_id:e,byxkh_meijie_name:f.label}))
                            }}
                        />
                        <Form.Item
                            label='获取日期'
                            name='date'
                            wrapperCol={{span:10}}
                            required                            
                        >
                            <DatePicker 
                                onChange={(e) => {setInfo(prevState=>({...prevState,byxkh_riqi:dayjs(e).format('YYYY-MM-DD')}))}} 
                            />
                        </Form.Item> 
                        <GetWebGoods
                            label='商品'
                            wrapperCol={{span:10}}
                            onChange={(e,f) => {
                                console.log(e,f);
                                setInfo(prevState=>({...prevState,byxkh_bg_id:e,byxkh_bg_name:f}))
                            }}
                            name='byxkh_bg_id'
                        />
                        <Form.Item
                            label='备注'
                            wrapperCol={{span:20}}
                        >
                           <Input
                                onChange={(e) => {setInfo(prevState=>({...prevState,byxkh_content:e.target.value}))}}
                                defaultValue={info.byxkh_content}
                           />
                        </Form.Item>    
                    </Form>
                </Modal>
                <Modal 
                    open={openCheck.open} 
                    onOk={() => {}} 
                    onCancel={() => {setopenCheck({open:false})}}
                    width={1200}
                    cancelText='关闭'
                    footer={(_, { OkBtn, CancelBtn }) => (
                        <>
                            <Button
                                onClick={() => {
                                    setopenCheck(false);
                                    setOpen(true)
                                }}
                            >再增一条</Button>
                            <CancelBtn />
                        </>
                    )}
                >
                    <ClientDesc
                        bxm_id={openCheck.id}
                    />
                </Modal> 
            </>
        )
}

export default LeadAdd